import { render, staticRenderFns } from "./CdbCustomerTourPage.vue?vue&type=template&id=40a2bd1e&scoped=true&"
import script from "./CdbCustomerTourPage.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerTourPage.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerTourPage.vue?vue&type=style&index=0&id=40a2bd1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a2bd1e",
  null
  
)

export default component.exports